module.exports = __webpack_public_path__ + "assets/img/3-3.0ce85f3f.jpg";